import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey, } from "../CommonComponents/CustomHooks";
import { FormButton, InputBox } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";
const CancelPickup = () => {
    const dispatch = useDispatch();
    const inputrefs = useRef([])
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [timer, setTimer] = useState(0);
    const [formData, setFormData] = useState({
        referenceNo: '',
        remarks: ''
    });

    const handleCancel = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Operation/CancelPickUprequest', formData)
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    }

    const handleClear = () => {
        setFormData({
            referenceNo: '', 
            remarks: ''
        })
    }
    const GetawbNoDetail = async (value, CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            referenceNo: value,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setIsLoading(true)
        let data = await ApiCall('/api/Operation/GetawbNoDetail', GetData)
        setTableData(data)
        setIsLoading(false)
        if (data.status === 'ERROR' || data.status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
       
    }

    useEffect(() => {
        inputrefs.current['txtReferenceNo'].focus()
        document.title = 'Cancel Pickup'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <span className="fs-6 fw-bold headingspan"> {FindTranslatedKey('Cancel Pickup')}</span>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <InputBox
                                label='Pick Up Ref No'
                                required={true}
                                inputrefs={inputrefs}
                                id="txtReferenceNo"
                                PlaceHolderText='Pick Up Ref No'
                                maxLength='50'
                                value={formData.referenceNo}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtRemarks'].focus()
                                    }
                                }}
                                onChange={(event) => {
                                    if (timer) {
                                        clearTimeout(timer)
                                    }
                                    setFormData({
                                        ...formData, referenceNo: event.target.value
                                    })
                                    setTimer(
                                        setTimeout(() => {
                                            if (event.target.value !== '') {
                                                GetawbNoDetail(event.target.value)
                                            }
                                        }, [900]))
                                }}
                            />
                            <InputBox
                                label='Remarks'
                                required={true}
                                inputrefs={inputrefs}
                                id="txtRemarks"
                                PlaceHolderText='Remarks'
                                maxLength='50'
                                value={formData.remarks}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    }
                                }}
                                onChange={(e) => {
                                    setFormData({
                                        ...formData,
                                        remarks: e.target.value
                                    })
                                }}
                            />
                            <div className='col-md-2 mt-3'>
                                <FormButton
                                    id={'btnSub'}
                                    cancel={true}
                                    save={false}
                                    Export={false}
                                    Reset={false}
                                    inputrefs={inputrefs}
                                    handleClear={handleClear}
                                    handleCancel={handleCancel}
                                />
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <Table
                tableData={tableData}
                currentPageNo={currentPageNo}
                Filter={false}
                loading={isLoading}
            />
        </>
    )
}
export default CancelPickup;